import { BiDotsVerticalRounded } from 'react-icons/bi';
import { MdOutlineContentCopy } from 'react-icons/md';
import styled from 'styled-components';

export const Container = styled.div`
  max-height: 600px;
  min-height: 150px;
  overflow: auto;
`;

export const DetailsWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 0;
  & + div {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
  }

  @media (max-width: 768px) {
    display: grid;
    grid-template-areas:
      'vencimento valor opcoes'
      'volume situacao .';
  }
`;

type GridAreaProps = {
  gridArea: string;
};
export const TitleAndValueWrap = styled.div<GridAreaProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 100px;

  @media (max-width: 768px) {
    grid-area: ${({ gridArea }) => gridArea};
  }
`;

export const Title = styled.span`
  font-family: 'Mangueira Bold', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 19px;
  color: #0b29fb;
`;

export const Value = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  color: #828282;
`;

export const OptionsWrap = styled.div<GridAreaProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    grid-area: ${({ gridArea }) => gridArea};
  }
`;

export const CopyCodeWrap = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

export const CopyCodeText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  color: #0b29fb;
  display: inline-flex;
  margin-left: 8px;
  margin-top: 3px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ControlsWrap = styled.div`
  margin-left: 32px;
  cursor: pointer;
  position: relative;

  @media (max-width: 768px) {
    margin-left: unset;
  }
`;

export const StatusWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ValueStatus = styled(Value)`
  text-transform: capitalize;
  display: inline-flex;
  margin-top: 2px;
  margin-left: 2px;
`;

type StatusProps = {
  color: string;
};

export const Status = styled.div<StatusProps>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ color }) => color};
`;

export const IconCopy = styled(MdOutlineContentCopy)``;

export const IconDots = styled(BiDotsVerticalRounded)``;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  position: absolute;
  width: 176px;
  right: 21px;
  top: 2px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding: 15px;
  box-shadow: 0px 2px 4px #00000034;
`;

export const MenuItem = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  color: ${({ theme }) => theme.colors.blue};

  &:hover {
    opacity: 0.5;
  }
`;
